import React from 'react';
import { Link } from 'react-router-dom';

// Friendly "Page not found" for an unknown portal address (review L1). Before
// this, /staff/<typo> matched no route and rendered a blank white page.
// Rendered inside the portal layout (shell + nav survive) and, for addresses
// that miss the layout entirely, standalone.
export default function PortalNotFound({ homeTo = '/staff', homeLabel = 'Go to staff Home' }) {
  return (
    <div className="max-w-xl mx-auto px-4 sm:px-6 py-16 text-center">
      <svg viewBox="0 0 24 24" className="w-7 h-7 mx-auto mb-3 text-primary/25" aria-hidden="true" fill="none">
        <path d="M10.5 17.2V4.9c3 .9 4.7 2.7 4.7 5.2 0 1.1-.3 2.1-.9 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <ellipse cx="8.1" cy="17.4" rx="2.6" ry="2" fill="currentColor" />
      </svg>
      <h1 id="portal-notfound-title" className="font-headline text-2xl text-on-surface m-0 mb-2">Page not found</h1>
      <p className="text-sm text-on-surface-variant mt-0 mb-6">
        That address isn&apos;t a page in the portal — it may be an old or mistyped link.
      </p>
      <Link
        to={homeTo}
        className="inline-flex items-center justify-center min-h-11 px-5 rounded-full bg-primary text-on-primary font-label text-sm hover:bg-primary/90 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
      >
        {homeLabel}
      </Link>
    </div>
  );
}
